import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from "@angular/router";
import { EscalatedRisk } from '../../_interfaces/EscalatedRisk.model';
import { RepositoryService } from './../../shared/services/repository.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { RiskUser } from '../../_interfaces/RiskUser.model';




@Component({
  selector: 'app-add-escalated-risk',
  templateUrl: './add-escalated-risk.component.html',
  styleUrls: ['./add-escalated-risk.component.css']
})
export class AddEscalatedRiskComponent implements OnInit {
  riskDetail: EscalatedRisk;
  riskAddForm: FormGroup;
  submitted = false;
  riskUsers: RiskUser[];
  //departments: Department[];

  constructor(private formBuilder: FormBuilder,
    private repository: RepositoryService,
    private router: Router,
    private activeRoute: ActivatedRoute) { }

  ngOnInit() {
    this.riskDetail = new EscalatedRisk();

    this.riskAddForm = this.formBuilder.group({
      description: ['', Validators.required],
      reviewDetails: ['', Validators.required],
      reviewResult: ['', Validators.min(0)],
      toBeReviewedBy: ['', Validators.required, Validators.min(0)],
      

    });

    this.getPeople();

  }

  onSubmit() {
    this.submitted = true;
    this.updateRiskFromForm();

    this.postRiskDetails();
  }

  onCancelForm() {
    this.router.navigate([`/myrisks/escalated`]);
  }

  updateRiskFromForm() {
    if (this.f.reviewResult.value) {
      this.riskDetail.reviewResult = + this.f.reviewResult.value;
    }
    if (this.f.toBeReviewedBy.value) {
      this.riskDetail.toBeReviewedBy = + this.f.toBeReviewedBy.value;
    }

     // non-numeric fields
    this.riskDetail.description = this.f.description.value;
    this.riskDetail.reviewDetails = this.f.reviewDetails.value;
  }

  postRiskDetails() {
    let apiAddress: string = `escalatedrisks`;

    this.repository.create(apiAddress, this.riskDetail)
      .subscribe(res => {
        // this.riskDetail = res as Risk;
        //this.router.navigate(["../../risks"], { relativeTo: this.activeRoute });
        this.router.navigate([`/myrisks/escalated`]);
      }, error => {
        alert('Error:!' + error.message + '\n\n');
          this.router.navigate([`/myrisks/escalated`]);
      },
        () => this.router.navigate([`/myrisks/escalated`])
      );
  }

  public isActive = (element, index, array) => {
    return (element.dormant === 0);
  };

  public isRiskAdmin = (element, index, array) => {
    return (element.superAdmin === 1 && element.dormant === 0);
  };

  public getPeople() {
    let apiAddress: string = `Users/UserList`;
    this.repository.getData(apiAddress)
      .subscribe(res => {
        const riskUsers = res as RiskUser[];
        this.riskUsers = riskUsers.filter(this.isRiskAdmin);
      });
  }

  get f() { return this.riskAddForm.controls; }

}
